import { createEntityAdapter } from '@reduxjs/toolkit';
import { DeviceStatusConnectionAPIResponse } from '../../device.model';

export const DeviceStatusAdapter = createEntityAdapter<
  DeviceStatusConnectionAPIResponse,
  string
>({
  selectId: (deviceStatus: DeviceStatusConnectionAPIResponse) =>
    deviceStatus.deviceID,
});
